// extracted by mini-css-extract-plugin
export default {"root":"SearchFilter_root__RsJ9q","wrapper":"SearchFilter_wrapper__9puJ+","container":"SearchFilter_container__jM2rG","expanded-filters":"SearchFilter_expanded-filters__b2c8Z"};